import React from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import { history, store } from './store';

import './index.scss';

import App from './App';

import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_CUSTOM_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.REACT_APP_CUSTOM_ENV,
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
